import { render, staticRenderFns } from "./PurPayableList.vue?vue&type=template&id=08a595f8&scoped=true&"
import script from "./PurPayableList.vue?vue&type=script&lang=js&"
export * from "./PurPayableList.vue?vue&type=script&lang=js&"
import style0 from "./PurPayableList.vue?vue&type=style&index=0&id=08a595f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a595f8",
  null
  
)

export default component.exports